import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DataSourceType } from 'src/app/domainObjects/dataSourceType';
import { DataTransformConfigViewModel } from 'src/app/viewModels/dataTransformConfigViewModel';
import { BaseComponent } from 'src/app/base/base.component';
import { ErrorReportingService } from 'src/app/services/errorReporting/error-reporting.service';
import { UserDataService } from 'src/app/services/user-data-service';
import { GeneralParameter } from 'src/app/domainObjects/ingestTransforms';
import { NgModel } from '@angular/forms';

@Component({
    selector: 'app-parameter-data-connector',
    templateUrl: './parameter-data-connector.component.html',
    styleUrls: ['./parameter-data-connector.component.css'],
    standalone: false
})

export class ParameterDataConnectorComponent extends BaseComponent implements OnInit {
  @Input() dataSourceType: DataSourceType;
  @Input() dataTransformConfigViewModel: DataTransformConfigViewModel;

  viewModel: GeneralParameter;

  constructor(
    matDialog: MatDialog,
    errorLogger: ErrorReportingService,private userData: UserDataService) {
      super(errorLogger, matDialog);
    }

  ngOnInit(): void {
    this.viewModel =this.dataTransformConfigViewModel.GeneralParameter;
    if (this.viewModel.farmType==0) {
      var farmtypeid=this.userData.getSelectedNodeDetails().farmtypeid;
      this.viewModel = new GeneralParameter(farmtypeid, 0, ' ', '', 'False', '', '', '0', '');
      this.dataTransformConfigViewModel.GeneralParameter=this.viewModel;
    }
  }

  ngOnChanges(changes: any) {
     this.viewModel =this.dataTransformConfigViewModel.GeneralParameter;
  }
  // Allow only optional '-' at the beginning and digits
  allowOnlyIntegers(event: KeyboardEvent): void {
    const char = event.key;
    const input = (event.target as HTMLInputElement).value;

    // Allow: backspace, delete, arrow keys
    if (['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'].includes(char)) {
      return;
    }

    // Allow single '-' only at the start
    if (char === '-' && input.length === 0) {
      return;
    }

    // Prevent if not a digit
    if (!/^\d$/.test(char)) {
      event.preventDefault();
    }
  }

  validatePaste(event: ClipboardEvent): void {
    const clipboardData = event.clipboardData?.getData('text') ?? '';
    const trimmed = clipboardData.trim();

    if (!/^[-]?\d*$/.test(trimmed)) {
      event.preventDefault();
    }
  }
  // Allows digits, optional leading minus, and a single decimal point
  allowOnlyFloats(event: KeyboardEvent): void {
    const char = event.key;
    const input = (event.target as HTMLInputElement).value;

    // Allow control keys
    if (['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'].includes(char)) {
      return;
    }

    // Allow minus only at start
    if (char === '-' && input.length === 0) {
      return;
    }

    // Allow one dot only if not already present
    if (char === '.' && !input.includes('.')) {
      return;
    }

    // Allow digits
    if (/^\d$/.test(char)) {
      return;
    }

    // Prevent anything else
    event.preventDefault();
  }

  validateFloatPaste(event: ClipboardEvent): void {
    const clipboardData = event.clipboardData?.getData('text') ?? '';
    const trimmed = clipboardData.trim();

    // Match optional minus, digits, optional dot and digits
    const floatRegex = /^-?\d*(\.\d*)?$/;

    if (!floatRegex.test(trimmed)) {
      event.preventDefault();
    }
  }
  allowOnlyPositiveFloats(event: KeyboardEvent): void {
    const char = event.key;
    const input = (event.target as HTMLInputElement).value;

    // Allow control keys
    if (['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'].includes(char)) {
      return;
    }

    // Prevent minus sign
    if (char === '-') {
      event.preventDefault();
      return;
    }

    // Allow only one dot
    if (char === '.' && !input.includes('.')) {
      return;
    }

    // Allow digits
    if (/^\d$/.test(char)) {
      return;
    }

    // Block anything else
    event.preventDefault();
  }

  validatePositiveFloatPaste(event: ClipboardEvent): void {
    const clipboardData = event.clipboardData?.getData('text') ?? '';
    const trimmed = clipboardData.trim();

    // Regex: starts with digits (optional), optional dot and digits, no negative sign
    const positiveFloatRegex = /^\d*(\.\d*)?$/;

    if (!positiveFloatRegex.test(trimmed)) {
      event.preventDefault();
    }
  }
  timestampError: string = '';
  validateTimestamp(control: NgModel): void {
    this.timestampError = '';
    control.control.setErrors(null);  // Clear previous errors
    const input = this.viewModel.timestampDefVal?.trim();
    if (!input) {
      return;
    }
    const timestampRegex = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/;
    if (!timestampRegex.test(input)) {
      this.timestampError = 'Invalid format. Use yyyy-MM-dd HH:mm:ss';
      control.control.setErrors({ invalidTimestamp: true });
      control.control.markAsTouched();
      return;
    }
  }
  timestampErrorRaw: string = '';
  validateTimestampRaw(control: NgModel): void {
    this.timestampErrorRaw = '';
    control.control.setErrors(null);  // Clear previous errors
    const input = this.viewModel.rawDataDefault?.trim();
    if (!input) {
      return;
    }
    const timestampRegex = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/;
    if (!timestampRegex.test(input)) {
      this.timestampErrorRaw = 'Invalid format. Use yyyy-MM-dd HH:mm:ss';
      control.control.setErrors({ invalidTimestamp: true });
      control.control.markAsTouched();
      return;
    }
  }
}
